import { render, staticRenderFns } from "./SHTableSessionCard.vue?vue&type=template&id=095b9336&scoped=true"
import script from "./SHTableSessionCard.vue?vue&type=script&lang=ts"
export * from "./SHTableSessionCard.vue?vue&type=script&lang=ts"
import style0 from "./SHTableSessionCard.vue?vue&type=style&index=0&id=095b9336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b9336",
  null
  
)

export default component.exports